namespace GeniuzPOS.Inventory {
    export interface IcStockSoldForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        WhsId: Serenity.LookupEditor;
        StockTo: Serenity.LookupEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        SoldDtList: IcStockSoldDtEditor;
    }

    export class IcStockSoldForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockSold';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockSoldForm.init)  {
                IcStockSoldForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.TextAreaEditor;
                var w5 = IcStockSoldDtEditor;

                Q.initFormType(IcStockSoldForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'WhsId', w2,
                    'StockTo', w2,
                    'PostFg', w3,
                    'CancelFg', w3,
                    'Remark', w4,
                    'SoldDtList', w5
                ]);
            }
        }
    }
}
